module.exports = __webpack_public_path__ + "img/logo.cc423fac.png";